import { UserRoleActionType, UserRolesAction } from '../actionTypes/userRole';
import { UserRole } from 'susy-common/models';

const UserRoleReducer = (
    state: Array<UserRole> = [],
    action: UserRolesAction
) => {
    switch (action.type) {
        case UserRoleActionType.GET_ALL_USER_ROLES:
            return action.payload;
        default:
            return state;
    }
};

export default UserRoleReducer;

